import { Infobox } from '@cognite/cogs.js-v10';
import styled from 'styled-components';

export const StyledInfobox = styled(Infobox)`
  .cogs-lab-infobox-content {
    display: inline;
  }
`;
